import * as React from 'react'
import { StyleguideImgPlaceholder } from '../helpers'

export const FakeCaseBlock = () => {
  return (
    <section className="block block--cases">
      <div className="block__inner gutter--default">
        <div className="block__content">
          <button className="block__button block__prev button--chevron button--prev">
            <svg className="block__icon" width="12" height="16">
              <use xlinkHref="#icon--caret" />
            </svg>
          </button>
          <ul className="block__list"
          >
            <li className="block__case case">
              <div className="case__inner">
                <div className="case__content content">
                  <header className="case__header">
                    <h2 className="case__title title title--l">Cras Ipsum Pellentesque</h2>
                    <div className="case__intro intro text--styled">
                      <p>
                        Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vestibulum id
                        ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo.
                      </p>
                    </div>
                    <span className="case__label">Porta</span>
                  </header>
                  <footer className="case__footer">
                    <div className="case__column">
                      <a href="/" className="case__link button--secondary">
                        Lees meer
                      </a>
                    </div>
                    <div className="case__column">
                      <span className="case__milestone active"></span>
                      <span className="case__milestone"></span>
                      <span className="case__milestone"></span>
                    </div>
                  </footer>
                </div>
                <div className="case__visual visual">
                  <img
                    src={StyleguideImgPlaceholder({
                      shape: { width: 650, height: 460, radius: '0', bgColor: '#EE7D11' },
                      text: { color: '#FFF', font: 'Open Sans, sans-serif' }
                    })}
                    alt="Etiam rhoncus"
                    width="650"
                    height="460"
                    className="case__image"
                  />
                </div>
              </div>
            </li>
          </ul>
          <button className="block__button block__next button--chevron button--next">
            <svg className="block__icon" width="12" height="16">
              <use xlinkHref="#icon--caret" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  )
}
